import vue from "vue";
import store from "@/store";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import i18n from "../i18n";

export default {
  handleError(error) {
    if (error.response) {
      const { errors } = error.response.data;
      if (errors) {
        Object.keys(errors).forEach(e => {
          errors[e].forEach(message =>
            vue.$toast.error(`${message}`, {
              position: "top-right"
            })
          );
        });
      } else if (error.response.data) {
        const dataError = error.response.data.data;
        if (dataError) {
          Object.keys(dataError).forEach(e => {
            dataError[e].forEach(message =>
              vue.$toast.error(`${message}`, {
                position: "top-right"
              })
            );
          });
        } else {
          if (error.response.status !== 401) {
            const message = error.response
            vue.$toast.error(error.response.status === 500 ? `Error ${error.response.status}. ${error.response.statusText}` : message.data.message, {
              position: "top-right"
            })
          } else if (error.response.config.url !== "/api/user") {
            vue.$toast.error(error.response.data.message, {
              position: "top-right"
            })
          }
        }
      } else {
        vue.$toast.error(error.response.data.message, {
          position: "top-right"
        })
      }
    }
  },
  can(vm) {
    let user = store.getters["user"];
    let roles = vm.split(';')
    let check
    for (let i = 0; i < roles.length; i++) {
      check = user.roles.find((e) => e.i18n === roles[i])
      break
    }
    return check ? true : false;
  },
  async showMsgConfirm({tittle, msg}) {
    const confirm = await Swal.fire({
      title: tittle ? i18n.t(tittle) : '',
      text: msg ? i18n.t(msg) : '',
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#172b4d",
      cancelButtonColor: "#d33",
      confirmButtonText:  i18n.t("yes"),
      cancelButtonText:  i18n.t("not"),
    }).then(async (result) => {
      return result.isConfirmed
    });
    return confirm
  },
  //Covert any dataURL to file Object JS
  dataURLtoFile(dataurl, filename) {
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  },

  sortBy(array, cfg) {
    var toString = Object.prototype.toString,
      // default parser function
      parse = function (x) {
        return x;
      },
      // gets the item to be sorted
      getItem = function (x) {
        var isObject = x != null && typeof x === "object";
        var isProp = isObject && this.prop in x;
        return this.parser(isProp ? x[this.prop] : x);
      };

    /**
     * Sorts an array of elements.
     *
     * @param {Array} array: the collection to sort
     * @param {Object} cfg: the configuration options
     * @property {String}   cfg.prop: property name (if it is an Array of objects)
     * @property {Boolean}  cfg.desc: determines whether the sort is descending
     * @property {Function} cfg.parser: function to parse the items to expected type
     * @return {Array}
     */
    if (!(array instanceof Array && array.length)) return [];
    if (toString.call(cfg) !== "[object Object]") cfg = {};
    if (typeof cfg.parser !== "function") cfg.parser = parse;
    cfg.desc = cfg.desc ? -1 : 1;
    return array.sort(function (a, b) {
      a = getItem.call(cfg, a);
      b = getItem.call(cfg, b);
      return cfg.desc * (a < b ? -1 : +(a > b));
    });
  }
};
